import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Redirect from '@/views/Redirect'
import Result from '@/views/Result'
import NotFound from '@/views/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:tenantCode?/redirect',
      name: 'redirect',
      component: Redirect
    },
    {
      path: '/:tenantCode?/result',
      name: 'result',
      component: Result
    },
    {
      path: '/:tenantCode?/404',
      name: '404',
      component: NotFound
    },
    {
      path: '/:tenantCode?',
      name: 'home',
      component: Home
    },
    {
      path: '/:tenantCode?/*',
      redirect: '/:tenantCode?/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js